import {GlobalTranslation} from '@screens/review-section2/document-review/review-translations';
import {FocusedError} from '@screens/review-section2/styles';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RequestStatus} from '@models/request-status';

export interface IErrorStore {
  confirmationRequestStatus: RequestStatus;
}

interface IProps {
  store: IErrorStore;
  globalTranslations: Record<GlobalTranslation, string>;
}

export const ReviewErrors: React.FunctionComponent<IProps> = observer(props => {
  const {
    store,
    globalTranslations
  } = props;

  // invalidity message shown first assuming that the form has to be valid before
  // the confirmation request is allowed to be sent
  const conditionalMessages: Array<{ condition: boolean; message: string; }> = [
    {condition: store.confirmationRequestStatus === 'error', message: globalTranslations.requestFailure}
  ];

  const errorMessage = conditionalMessages.find(({condition}) => condition === true)?.message ?? null;

  return (
    <FocusedError>{errorMessage}</FocusedError>
  );
});



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-review/review-errors.tsx